import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { CheckAnimationIcon } from '@nv/images/design/check-animation-icon'
import { XCircleAnimatedIcon } from '@nv/images/design/x-circle-animated-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './NVBasicModal.module.scss'

export const NVBasicModal = ({ title, text, icon, navigateTo, error, success, onClickOk = null, buttonText }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const navigate = useNavigate()

  useEffect(() => {
    setHeaderLabel(title)
    setBtns([
      {
        text: buttonText ? buttonText : t('buttons.ok'),
        onClick: onClickOk ? () => onClickOk() : () => (navigateTo ? navigate(navigateTo) : onClose()),
      },
    ])
  }, [])

  const selectedIcon = error ? <XCircleAnimatedIcon /> : success ? <CheckAnimationIcon /> : icon

  return (
    <div className={clsx(styles['container'], { [styles['success']]: success, [styles['error']]: error })}>
      {selectedIcon && <div className={styles['svg']}>{selectedIcon}</div>}
      <div className={styles['title']}>{text}</div>
    </div>
  )
}
